import React from 'react';
import { ReactComponent as EditIcon } from '../../icons/edit.svg';
import './reply-form.scss';

interface ReplyFormProps {
  replyText: string;
  onReplyTextChange: (text: string) => void;
  onSave: () => void;
  onCancel: () => void;
  isSaving: boolean;
  placeholder?: string;
  label?: string;
  smallWidth?: boolean;
}

/**
 * Reusable component for adding a reply/comment
 */
const ReplyForm: React.FC<ReplyFormProps> = ({
  replyText,
  onReplyTextChange,
  onSave,
  onCancel,
  isSaving,
  placeholder = '',
  label = 'Add comment',
  smallWidth = false,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    // Submit on Cmd/Ctrl + Enter
    if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
      e.preventDefault();
      if (!isSaving && replyText.trim()) {
        onSave();
      }
    }
  };

  return (
    <div className={`add-note-form ${smallWidth ? 'small-width' : ''}`}>
      <div className='form-title'>
        <span>
          <EditIcon /> {label}
        </span>
        {!smallWidth && (
          <div className='form-buttons'>
            <button
              className='cancel-button'
              onClick={onCancel}
              disabled={isSaving}
            >
              Cancel
            </button>
            <button
              className='save-button'
              onClick={onSave}
              disabled={isSaving || !replyText.trim()}
            >
              {isSaving ? 'Saving...' : 'Save'}
            </button>
          </div>
        )}
      </div>
      <textarea
        className='form-textarea'
        value={replyText}
        onChange={(e) => onReplyTextChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={isSaving}
      />
      {smallWidth && (
        <div className='form-buttons bottom'>
          <button
            className='cancel-button'
            onClick={onCancel}
            disabled={isSaving}
          >
            Cancel
          </button>
          <button
            className='save-button'
            onClick={onSave}
            disabled={isSaving || !replyText.trim()}
          >
            {isSaving ? 'Saving...' : 'Save'}
          </button>
        </div>
      )}
    </div>
  );
};

export default ReplyForm;
